import React, { useState } from "react";

import { IoSearch } from "react-icons/io5";
import { useFilterContext } from "../../Context/FilterContext";

const Buscador = () => {
  const { searchText, setSearchText } = useFilterContext();
  const [text, setText] = useState(searchText);

  const handleChange = (e) => {
    setText(e.target.value);
  };
  const handleSearch = (e) => {
    e.preventDefault();
    setSearchText(text);
  };

  return (
    <div className="flex items-center h-[50px]">
      <div
        className=" flex items-center flex-shrink rounded-2xl w-full h-[100%] lg:w-[800px] border border-solid border-slate-200
                
            "
      >
        <form className="rounded-2xl bg-slate-100 transition-all focus-within:bg-white focus-within:ring-2 focus-within:ring-sky-400 focus-within:sky-400 flex items-center h-[100%] w-[100%] ">
          <button
            type="submit"
            className=" text-slate-400 hover:text-white hover:bg-sky-500 hover-text-white transition-all duration-500 bg-sky-200 p-2 w-[40px] rounded-tl-2xl rounded-bl-2xl w-[50px] h-[100%] flex items-center justify-center"
            onClick={handleSearch}
          >
            <IoSearch className="text-[25px]" />
          </button>

          <input
            type="text"
            value={text}
            onChange={handleChange}
            placeholder="Pizza de Jamon, Hamburguesa, Hela..."
            className="py-1 px-2 bg-transparent text-md font-Roboto"
          />
        </form>
      </div>
    </div>
  );
};

export default Buscador;
